import { useCallback } from 'react';
import { usePopout } from './usePopout';

const DEFAULT_WIDTH = 600;
const DEFAULT_HEIGHT = 550;

export function useJournalPopout() {
  const popout = usePopout();

  const openEditor = useCallback((entryId: string) => {
    const existing = popout.popouts.find(p => p.sheetId === entryId);
    if (existing) {
      popout.bringToFront(existing.id);
    } else {
      popout.add(entryId, DEFAULT_WIDTH, DEFAULT_HEIGHT);
    }
  }, [popout]);

  const closeEditor = useCallback((entryId: string) => {
    const found = popout.popouts.find(p => p.sheetId === entryId);
    if (found) popout.remove(found.id);
  }, [popout]);

  return { ...popout, openEditor, closeEditor };
}
